var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgItemCardAnalytic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 148,
    viewBox: "0 0 257 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_261_4238",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: -45,
    width: 317,
    height: 257
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M214.622 58.7555C316.983 166.244 272.593 231.602 115.248 204.619C-42.0974 177.636 -25.2788 150.069 152.655 143.101C330.588 136.134 375.098 70.7731 252.028 -2.76204C128.958 -76.2971 112.26 -48.7329 214.622 58.7555Z",
    stroke: "#404040",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M211.972 62.4902C294.144 156.527 253.544 216.13 121.34 195.558C-10.8635 174.986 4.34777 149.87 155.429 139.469C306.51 129.068 347.11 69.4647 246.06 6.40112C145.01 -56.6625 129.796 -31.6509 211.972 62.4902Z",
    stroke: "#404040",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M209.198 66.1227C273.375 147.492 236.685 201.338 127.309 186.395C17.9326 171.451 31.6535 148.678 158.196 135.626C284.738 122.575 321.308 68.7317 240.085 15.3544C158.862 -38.023 145.02 -15.2468 209.198 66.1227Z",
    stroke: "#404040",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M206.548 69.8569C254.803 139.348 222.026 187.541 133.28 177.336C44.5384 167.236 56.8926 146.908 160.849 131.996C264.806 117.085 297.586 68.9963 234.116 24.5171C170.646 -19.9622 158.172 0.369046 206.548 69.8569Z",
    stroke: "#404040",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M203.774 73.4898C238.3 131.887 209.433 174.323 139.249 168.173C69.0643 162.024 79.9348 144.248 163.499 128.262C247.064 112.276 276.051 69.837 228.024 33.5784C179.997 -2.68032 169.25 15.1971 203.774 73.4898Z",
    stroke: "#404040",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M201.124 77.2247C224.112 125.209 199.155 161.887 145.342 159.113C91.5276 156.338 100.908 140.905 166.391 124.522C231.877 108.243 256.834 71.565 222.173 42.634C187.512 13.7029 178.135 29.2402 201.124 77.2247Z",
    stroke: "#404040",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M198.353 80.9622C212 119.424 190.833 150.347 151.193 150.058C111.553 149.768 119.566 136.78 169.044 120.892C218.522 105.005 239.569 74.0838 216.205 51.797C192.84 29.5102 184.827 42.4977 198.353 80.9622Z",
    stroke: "#404040",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M195.699 84.5916C202.075 114.214 184.821 139.485 157.285 140.996C129.748 142.507 136.271 131.863 171.697 117.262C207.243 102.659 224.377 77.3904 210.112 60.8578C195.847 44.3253 189.324 54.9697 195.699 84.5916Z",
    stroke: "#404040",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M192.929 88.3291C194.106 109.9 180.882 129.41 163.257 131.938C145.627 134.361 150.663 126.164 174.468 113.525C198.273 100.886 211.496 81.3748 204.14 69.916C196.784 58.4573 191.752 66.7585 192.929 88.3291Z",
    stroke: "#404040",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M190.275 91.9588C188.568 106.26 179.137 120.121 169.345 122.772C159.553 125.423 162.982 119.677 177.238 109.787C191.495 99.8977 200.809 86.1444 198.168 78.9742C195.528 71.804 191.982 77.6574 190.275 91.9588Z",
    stroke: "#404040",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M187.505 95.6962C184.986 103.517 179.466 111.62 175.197 113.717C170.928 115.813 172.986 112.408 179.771 106.16C186.557 99.9134 192.077 91.8099 192.08 88.14C192.082 84.4702 190.023 87.8757 187.505 95.6962Z",
    stroke: "#404040",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_261_4238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.37109,
    y: -99.6151,
    width: 370.81,
    height: 370.81,
    fill: "url(#paint0_linear_261_4238)",
    fillOpacity: 0.05
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_261_4238",
    x1: 149.033,
    y1: 36.8611,
    x2: 201.524,
    y2: 158.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F80ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AACDF6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgItemCardAnalytic);
export default __webpack_public_path__ + "static/media/bg_item_card_analytic.5c07d7f773d5b7bd954be54e49ce5117.svg";
export { ForwardRef as ReactComponent };